<div class="containerMarginX">
    <h2 class="mt-4 ml-3 mb-3">{{ 'k003442' | translate }}</h2> <!-- Token: Main environment settings-->
    <div class="card-white w-100">
        <form [formGroup]="form" class="form-login fadeIn">  
            <div class="itemTask">
                <div class="taskName">{{ 'k003443' | translate }}</div><!-- Token: Language -->
                <div class="taskDescription">
                    {{ 'k003444' | translate }}
                </div><!-- Token: Change the default language of the platform -->
                <div class="taskButton">
                    <mat-select
                    class="selectLenguage"
                    formControlName ="language"
                    [(value)]="languageDefault"
                    (selectionChange)="change($event)"
                >
                    <mat-option
                    *ngFor="let language of languages"
                    [value]="language.FullCode"
                    [title]="language.Name"
                    >
                    {{ language.ShortCode }}
                    </mat-option>
                </mat-select>
                </div>
            </div>
            <div class="itemTask">
                <div class="taskName">{{ 'k003453' | translate }}</div><!-- Token: Theme images -->
                <div class="taskDescription">
                    {{ 'k003454' | translate }}
                </div><!-- Token: Allows modifying the images associated with the theme -->
                <div class="taskButton">
                    <mat-select
                    class="selectThemeImg"
                    formControlName ="themeImg"
                    [(value)]="themeImgDefault"
                    (selectionChange)="change($event)"
                >
                    <mat-option
                    *ngFor="let themeImg of themesImg"
                    [value]="themeImg"
                    >
                    {{ themeImg }}
                    </mat-option>
                </mat-select>
                </div>
            </div>
            <div class="itemTask">
                <div class="taskName">{{ 'k003451' | translate }}</div><!-- Token: Theme CSS style -->
                <div class="taskDescription">
                    {{ 'k003452' | translate }}
                </div><!-- Token: Allows modifying the CSS stylesheet associated with the theme -->
                <div class="taskButton">
                    <mat-select
                    class="selectThemeCSS"
                    formControlName ="themeCSS"
                    [(value)]="themeCssDefault"
                    (selectionChange)="change($event)"
                >
                    <mat-option
                    *ngFor="let themeCss of themesCss"
                    [value]="themeCss"
                    >
                    {{ themeCss }}
                    </mat-option>
                </mat-select>
                </div>
            </div>
            <div class="itemTask">
                <div class="taskName">
                    {{'k003445'|translate}}<!-- token: Onboarding -->
                </div>
                <div class="taskDescription">
                    {{'k003446'|translate}}
                </div><!-- Token: Set the onboarding type -->
                <div class="taskButton">
                    <div class="taskButton">
                        <dx-radio-group 
                        [dataSource]="onboardingOptions"
                        [value]="onboardingOptionsDefault"
                        valueExpr="id"
                        formControlName ="onboardingType"
                        itemTemplate="templateOnboarding"
                        layout="horizontal"
                        (onValueChanged)="change($event)"
                        >
                        <div class="templateOnboarding" *dxTemplate="let data of 'templateOnboarding'">
                            {{data.text | translate}}
                        </div>
                        </dx-radio-group>
                    </div>
                </div>
            </div>
            <div class="itemTask">
                <div class="taskName">
                    {{'k003449'|translate}}<!-- token: New Account -->
                </div>
                <div class="taskDescription">
                    {{'k003450'|translate}}
                </div><!-- Token: Allows access to create a new account from the Login page -->
                <div class="taskButton">
                    <dx-radio-group 
                    [dataSource]="allowOpenNewAccountOptions"
                    [value]="allowOpenNewAccountDefault"
                    formControlName ="allowOpenNewAccount"
                    valueExpr="id"
                    itemTemplate="templateOpenNewAccount"
                    layout="horizontal"
                    (onValueChanged)="change($event)"
                    >
                    <div class="templateOpenNewAccount" *dxTemplate="let data of 'templateOpenNewAccount'">
                        {{data.text | translate}}
                    </div>
                    </dx-radio-group>
                </div>
            </div>
            <div class="itemTask">
                <div class="taskName">
                    {{'k003455'|translate}}<!-- token: SMS verification -->
                </div>
                <div class="taskDescription">
                    {{'k003456'|translate}}
                </div><!-- Token: Allows performing verifications on the platform using SMS -->
                <div class="taskButton">
                    <dx-radio-group 
                    [dataSource]="smsVerificationOptions"
                    [value]="smsVerificationDefault"
                    formControlName ="smsVerification"
                    valueExpr="id"
                    itemTemplate="templateSmsVerification"
                    layout="horizontal"
                    (onValueChanged)="change($event)"
                    >
                    <div class="templateSmsVerification" *dxTemplate="let data of 'templateSmsVerification'">
                        {{data.text | translate}}
                    </div>
                    </dx-radio-group>
                </div>
            </div>
        </form>
    </div>
    <div class="buttonContainerFlex flex-space-between">
        <button
      type="button"
      class="buttonPortal lg cancel my-4"
      mat-raised-button
      (click)="reset()"
      >
      <span>{{'k003461'|translate}}</span>
      <!-- Token: Reset -->
    </button>
    <button
    type="button"
    class="buttonPortal lg my-4"
    mat-raised-button
    (click)="update()"
    [disabled]="updateDisabled"
    >
    <span>{{ 'k000327' | translate }}</span>
    <!-- Token: Guardar cambios -->
        </button>
    </div>
</div>
  